import { widgetWrapperStyles } from "@tKgpco/theme/mixins";
import styled from "styled-components";

const WidgetWrapper = styled.div`
    ${widgetWrapperStyles()}
`;

export default WidgetWrapper;
